module.exports = __webpack_public_path__ + "static/img/Game.59bcd11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutemobi/imgs/browse/Game.jpg
// module id = 2233
// module chunks = 0